import { combineReducers } from 'redux';
import {
  OPEN_PLATFORM_APP_MARKET_SET_APPS,
  OPEN_PLATFORM_APP_MARKET_SET_APP_DETAIL,
  OPEN_PLATFORM_APP_MARKET_SHOW_DETAIL_MODAL,
  OPEN_PLATFORM_APP_MARKET_HIDE_DETAIL_MODAL,
} from 'actions/openPlatform/appMarket/constants';

import createReducer from 'utils/createReducer';

const appDetail = createReducer(null, {
  [OPEN_PLATFORM_APP_MARKET_SET_APP_DETAIL]: (draft, { payload }) =>
    payload.app,
});

const apps = createReducer([], {
  [OPEN_PLATFORM_APP_MARKET_SET_APPS]: (draft, { payload }) => payload.apps,
});

const showDetailModal = createReducer(false, {
  [OPEN_PLATFORM_APP_MARKET_SHOW_DETAIL_MODAL]: () => true,
  [OPEN_PLATFORM_APP_MARKET_HIDE_DETAIL_MODAL]: () => false,
});

export default combineReducers({
  appDetail,
  apps,
  showDetailModal,
});
